import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import AnketDavetBanner from '../components/AnketDavetBanner';
import './LoginPage.css';
import './BayiOnServisWizardPage.css';

function BayiHomePage({ onLogout }) {
  const { user } = useAuth();
  const displayName =
    user?.bayiAdi ||
    [user?.ad, user?.soyad].filter(Boolean).join(' ').trim() ||
    user?.kullaniciAdi ||
    'Bayi';

  return (
    <div className="login-container">
      <div className="login-card bayi-wizard-card">
        <div className="login-header">
          <div className="login-logo">
            <img src="/assets/img/logo.png" alt="Firma Logo" />
          </div>
          <h1>Bayi Yönetim Sistemi</h1>
          <p>Hoş geldiniz, {displayName}</p>
        </div>

        <AnketDavetBanner />
        <div className="bayi-home-actions">
          <Link to="/on-servis-kaydi" className="bayi-home-link-btn">
            Ön Servis Kaydı Oluştur
          </Link>
          <button type="button" className="bayi-home-link-btn secondary" onClick={onLogout}>
            Çıkış Yap
          </button>
        </div>
      </div>
    </div>
  );
}

export default BayiHomePage;
